import { render, staticRenderFns } from "./main.puc.vue?vue&type=template&id=f83424e2"
import script from "./main.puc.vue?vue&type=script&lang=js"
export * from "./main.puc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports